export default {
  getUserList: {
    method: 'get',
    url: 'user'
  },
  reviseUser: {
    method: 'put',
    url: 'user'
  },
  getUserRule: {
    method: 'get',
    url: 'platform/user/rule'
  },
  setUserRule: {
    method: 'post',
    url: 'platform/user/rule'
  },
  getOnlineTerminal: {
    method: 'get',
    url: 'user/online'
  }
}
